export enum AdditionalFAQField {
    None = "none",
    OrderRegistryNumber = "orderId"
}

export const parseCategory = (category?: string): AdditionalFAQField => {
    if (
        ["0101", "0102", "0401", "0402", "0500", "0602"].some(
            (v) => v === category
        )
    ) {
        return AdditionalFAQField.OrderRegistryNumber;
    }

    return AdditionalFAQField.None;
};
